import useSWR from 'swr';
import { SessionStatusFilter } from '@kouto/types';
import { useBrandId } from 'AppProvider';
import fetchSessions from './fetchSessions';
import buildSessionsUrl from './buildSessionsUrl';

const fetchSessionsSWR = ([url, { brandId }]: [string, { brandId: string }]) =>
  fetchSessions(url, { brandId });

const useSessions = ({
  listingId,
  from,
  to,
  skip = false,
  resourceGroupId,
  maxSessionsPerDay,
  status,
}: {
  listingId?: string | null;
  from?: Date;
  to?: Date;
  skip?: boolean;
  resourceGroupId?: string;
  maxSessionsPerDay?: number;
  status?: SessionStatusFilter;
}) => {
  const brandId = useBrandId();
  const url =
    listingId && !skip && from && to
      ? buildSessionsUrl(listingId, {
          from,
          to,
          resourceGroupId,
          maxSessionsPerDay,
          status,
        })
      : null;
  // A new date or month is a new key; the rows already on screen stay until the next arrive, so a click
  // repaints the cards instead of blanking them. `isLoading` still flips while the request is in flight.
  const swr = useSWR(url ? [url, { brandId }] : null, fetchSessionsSWR, {
    keepPreviousData: true,
  });

  return {
    ...swr,
    sessions: swr.data?.sessions ?? [],
  };
};

export default useSessions;
